module.exports = __webpack_public_path__ + "static/audio-aeebf0059417949ff6606cb4b2476488.gif";